import React, { useEffect, useState } from "react";
import { findInitialSchoolYear } from "../../../util/schoolYear";
import InsertStudentsSidebar from "../../../unicomponents/InsertStudentsSidebar";
import { useLocation } from "react-router-dom";
import useLessonStudents from "../../../hooks/useLessonStudentData";
import HelpHyperLink from "../../../unicomponents/HelpHyperLink";
import useLessons from "../../../hooks/useLessons";
import DropdownUniqueUsersInDisplayData from "../../../unicomponents/Dropdowns/DropdownUniqueUsersInDisplayData";
import DropdownTermDate from "../../../unicomponents/Dropdowns/DropdownTermDate";
import DropdownHierarchyThree from "../../../unicomponents/Dropdowns/DropdownHierarchyThree";
import DropdownHierarchyTwo from "../../../unicomponents/Dropdowns/DropdownHierarchyTwo";
import DropdownHierarchyOne from "../../../unicomponents/Dropdowns/DropdownHierarchyOne";
import DropdownSchoolYear from "../../../unicomponents/Dropdowns/DropdownSchoolYear";
import useOrganizationSetting from "../../../hooks/useOrganizationSetting";
import useTermPeriod from "../../../hooks/useTermPeriod";
import { setTermIdByToday } from "../../../util/dateRelated";
import { useAuthContext } from "../../../context/AuthContext";
import { useUIContext } from "../../../context/UIContext";
import DropdownUniqueItems from "../../../unicomponents/Dropdowns/DropdownUniqueItems";
import UniDivider from "../../../unicomponents/UniDivider";
import LessonStudentsTable from "./components/LessonStudentsTable";
import useUsers from "../../../hooks/useUsers";
import LessonStudentsItemsTable from "./components/LessonStudentsItemsTable";
import useLessonSetting from "../../../hooks/useLessonSetting";
import useSettingEvalItems from "../../../hooks/useSettingEvalItems";
import CustomTableSwitch from "./components/CustomTableSwitch";
import SimpleAlertMessageBlock from "../../../unicomponents/SimpleAlertMessageBlock";
import HavenExtraTable from "./components/customTables/HavenExtraTable";
import { useTranslation } from "react-i18next";
import useFlexibleData from "../../../hooks/useFlexibleData";
import useDaumSchoolConfirm from "../../../hooks/useDaumSchoolConfirm";
import SepumLessonStudentsItemsTable from "./components/customTables/SepumLessonStudentsItemsTable";
import useLessonPlans from "../../../hooks/useLessonPlans";
import LessonPlanRecordDrawer from "./components/LessonPlanRecordDrawer";

/* 복잡하군... 스텝을 정리해서 하자. 
1. 데이터 불러온다.
  - 조직, 학기 데이터 먼저, 그리고 수업데이터(교사, 수업목록), 선택된 수업 바탕으로 학생-수업 배정 데이터
2. 필터한다. (교사와 수업은 있으면 필터하고, 없으면 전체 다 보여주는 컨셉으로)
3. 선택된 과목 보여준다.
4. 성적수정 개별로, 전체로 할 수 있다. / 삭제(배정에서 빼기) 할 수 있다.
5. 학생을 배정한다. (side) 
6. 배정된 학생에게 평가제의 맞춰서 성적입력하는 테이블이 나온다.

5번에 bulkcreate, 그리고 6번만 하면 됨.
*/

export default function DoLessons() {
  const { t } = useTranslation();

  const location = useLocation();
  const paths = location.pathname.split("/");
  const schoolId = paths[1];
  const conditions = {
    schoolid: schoolId,
    // lesson_id: 이거 나중에 추가해야 함
  };

  const {
    settingQuery: { data: settingData },
  } = useOrganizationSetting(conditions);

  const {
    termPeriodQuery: { data: termPeriodData },
  } = useTermPeriod(conditions);

  const {
    lessonsQuery: { data: lessonsData },
    updateLessonTags,
  } = useLessons(conditions);

  const {
    lessonSettingQuery: { data: lessonSettingData },
  } = useLessonSetting(conditions);

  const {
    usersQuery: { data: userData },
  } = useUsers(conditions, { role: "teacher", status: 1 });

  const { getEvalItemsByLessonId } = useSettingEvalItems(conditions);

  const {
    getLessonStudentsByLessonId,
    createLessonStudents,
    createLessonStudentsBulk,
    updateLessonStudents,
    updateLessonStudentsBulk,
    deleteLessonStudents,
  } = useLessonStudents(conditions);

  const { user, hasPermission } = useAuthContext();

  const { handleToastCenterTop, setIsLoadingModal } = useUIContext();

  const [lessonInfo, setLessonInfo] = useState({
    id: "",
    evaluation_type: "",
    hierarchyOne: "",
    hierarchyTwo: "",
    hierarchyThree: "",
    school_year: "",
    schoolid: "",
    subject_name: "",
    teachers: [],
    termName: "",
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAdded, setIsAdded] = useState([]);
  const [isAddedAll, setIsAddedAll] = useState(false);
  // organizationPath로 하는 것이 아니라... 모든 곳에서 단순하게 filters로 하는 것이 낫겠다.
  //필요한 필터는 여기서 통합해서 사용하자. 그리고 필터가 서로 다르게 적용되어야 할 때가 있다.
  const [filters, setFilters] = useState({
    schoolYear: null,
    schoolYearId: "",
    hierarchyOneId: "",
    hierarchyTwoId: "",
    hierarchyThreeId: "",
    organPathForSort: "/",
    termId: "",
    selectedTeacherId: "",
    selectedLessonId: "",
  });

  const [termId, setTermId] = useState("");
  const [lessonList, setLessonList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [lessonStudentsData, setLessonStudentsData] = useState([]);
  const [lessonSetting, setLessonSetting] = useState([]);
  const [evalItemsData, setEvalItemsData] = useState([]);
  const [showEvalPlan, setShowEvalPlan] = useState(false);
  const [isLessonPlanDrawerOpen, setIsLessonPlanDrawerOpen] = useState(false);
  const [lessonPlanData, setLessonPlanData] = useState(null);

  // 수업계획서 조회 (mutation 방식)
  const { lessonPlanQuery, upsertLessonPlan } = useLessonPlans({
    schoolid: schoolId,
  });
  // 확인자 관련 상태
  const [isConfirmerLoggedIn, setIsConfirmerLoggedIn] = useState(false);
  const [loginKey, setLoginKey] = useState("");

  // 확인자 관련 flexibleData
  const {
    flexibleDataQuery: { data: confirmerFlexibleData },
  } = useFlexibleData({
    schoolid: schoolId,
    main_category: "daumschoolConfirm",
    sub_category: "dolessons",
  });

  // 확인자 기록 조회 및 생성
  const {
    daumSchoolConfirmQuery: { data: confirmRecordsData },
    createOrUpdateConfirm,
  } = useDaumSchoolConfirm({
    schoolid: schoolId,
    page: "dolessons",
  });

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // 확인자 로그인 핸들러
  const handleLoginClick = () => {
    if (!confirmerFlexibleData || confirmerFlexibleData.length === 0) {
      handleToastCenterTop("확인자 설정이 없습니다.");
      return;
    }

    const { password } = confirmerFlexibleData[0].data_value;

    if (loginKey === password) {
      setIsConfirmerLoggedIn(true);
      handleToastCenterTop("로그인 성공");
    } else {
      handleToastCenterTop("비밀번호가 일치하지 않습니다.");
    }
  };

  const handleLogoutClick = () => {
    setIsConfirmerLoggedIn(false);
    setLoginKey("");
    handleToastCenterTop("로그아웃 되었습니다.");
  };

  const handleLoginKeyChange = (e) => {
    setLoginKey(e.target.value);
  };

  useEffect(() => {
    let initialSchoolYear = null;
    let initialSchoolYearId = null;
    // let initialUsername = null;

    if (
      filters.schoolYear === null &&
      lessonsData &&
      settingData &&
      settingData.length > 0 &&
      termPeriodData !== undefined
    ) {
      const initialData = findInitialSchoolYear(settingData, {
        periodData: termPeriodData,
      })?.row;
      if (!initialData) return;

      initialSchoolYear = initialData.school_year;
      initialSchoolYearId = initialData.id;
      setFilters((filters) => ({
        ...filters,
        schoolYear: initialSchoolYear,
        schoolYearId: initialSchoolYearId,
      }));

      const sortedLessons = lessonsData.filter(
        (r) => r.school_year_id === initialSchoolYearId,
      );
      setLessonList(sortedLessons);

      // console.log("sortedLessons", sortedLessons);

      if (termPeriodData) {
        setTermIdByToday(termPeriodData, setTermId, initialSchoolYearId);
      }
    }
  }, [
    lessonsData,
    filters,
    filters.schoolYear,
    settingData,
    termId,
    termPeriodData,
  ]);

  useEffect(() => {
    if (lessonsData) {
      const sortedLessons = filterDataByOrganSettingDropdown(
        lessonsData,
        filters,
        termId,
        filters.selectedTeacherId,
      );
      setLessonList(sortedLessons);
    }
  }, [lessonsData, filters, termId]);

  useEffect(() => {
    if (userData && user) {
      if (user.role === "teacher") {
        setFilters((filters) => ({
          ...filters,
          selectedTeacherId: user.username,
        }));
      }
    }
  }, [user, userData]);

  useEffect(() => {
    if (!filters.selectedLessonId) {
      setLessonInfo({});
      setLessonPlanData(null);
      return;
    }
    if (lessonList && filters.selectedLessonId) {
      const selectedLessonInfo = lessonList.find(
        (lesson) =>
          lesson.id.toString() === filters.selectedLessonId.toString(),
      );
      setLessonInfo(selectedLessonInfo);
    }
  }, [filters.selectedLessonId, lessonList]);

  useEffect(() => {
    if (lessonInfo && lessonInfo.tags) {
      setSelectedOptions(lessonInfo.tags);
    }
  }, [lessonInfo]);

  useEffect(() => {
    if (lessonSettingData && termPeriodData) {
      let thisTermEndDate;

      if (termId) {
        // termId가 있을 경우, 해당 termId의 end_date를 찾습니다.
        const termData = termPeriodData.find((period) => period.id === termId);
        thisTermEndDate = termData ? new Date(termData.end_date) : undefined;
      } else {
        // termId가 null 혹은 undefined일 경우, termPeriodData 전체에서 가장 늦은 end_date를 찾습니다.
        thisTermEndDate = new Date(
          Math.max(
            ...termPeriodData.map((period) =>
              new Date(period.end_date).getTime(),
            ),
          ),
        );
      }

      if (thisTermEndDate) {
        const filteredAndSortedLessonSetting = lessonSettingData
          .filter((r) => new Date(r.start_date) <= thisTermEndDate) // start_date가 thisTermEndDate 이전인 항목을 필터링
          .sort((a, b) => new Date(b.start_date) - new Date(a.start_date)); // end_date 기준으로 내림차순 정렬

        // Use a reducer to keep only the first occurrence of each item_code
        const uniqueLessonSetting = filteredAndSortedLessonSetting.reduce(
          (acc, current) => {
            const x = acc.find((item) => item.item_code === current.item_code);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          },
          [],
        );
        setLessonSetting(uniqueLessonSetting);
      }
    }
  }, [lessonSettingData, termId, termPeriodData]);

  function filterDataByOrganSettingDropdown(
    arrayDataToBeFiltered,
    organSettingObj,
    termId,
    selectedUser,
  ) {
    /* 
필터해야 하는 것이
school_year_id = 이건 필수로 id(숫자)로 하지만.. 아래는 id이지만 문자이고, 0은 통합으로 쓰임 
hierarchy_one
hierarchy_two
hierarchy_three
term_id - 이건 아이디 숫자임, termDropdown의 id로 필터
-   const [termId, setTermId] = useState(""); 이거로 따로 있음
teachers: [{tname: "김샘플", username:"sample@sampleschool"}] 이런식으로 되어 있음. username으로 필터해야 함
 -   selectedUser, setSelectedUser = useState(""); 이거로 따로 있음
*/
    if (!arrayDataToBeFiltered) return [];

    const toBeRows = arrayDataToBeFiltered.filter((record) => {
      const matchesSchoolYearId = organSettingObj.schoolYearId
        ? String(record.school_year_id) === String(organSettingObj.schoolYearId)
        : true;
      const matchesHierarchyOne = organSettingObj.hierarchyOneId
        ? record.hierarchy_one === organSettingObj.hierarchyOneId
        : true;
      const matchesHierarchyTwo = organSettingObj.hierarchyTwoId
        ? record.hierarchy_two === organSettingObj.hierarchyTwoId
        : true;
      const matchesHierarchyThree = organSettingObj.hierarchyThreeId
        ? record.hierarchy_three === organSettingObj.hierarchyThreeId
        : true;
      const matchesTermId = termId
        ? String(record.term_id) === String(termId)
        : true;

      const matchesSelectedUser = selectedUser
        ? record.teachers.some((teacher) => teacher.username === selectedUser)
        : true;

      return (
        matchesSchoolYearId &&
        matchesHierarchyOne &&
        matchesHierarchyTwo &&
        matchesHierarchyThree &&
        matchesTermId &&
        matchesSelectedUser
      );
    });

    return toBeRows;
  }

  function queryLessonStudentsData(forWhere) {
    getLessonStudentsByLessonId.mutate(forWhere, {
      onSuccess: (data) => {
        if (settingData) {
          const settingMap = settingData.reduce((map, setting) => {
            map[setting.id] = setting.group_name;
            return map;
          }, {});

          const updatedData = data.map((studentData) => {
            const pathParts = studentData.organization_path.split("/");
            const stageId = pathParts[2]; // 과정
            const yearId = pathParts[3]; // 학년
            const classId = pathParts[4]; // 반

            const groupNameOne = settingMap[stageId];
            const groupNameTwo = settingMap[yearId];
            const groupNameThree = settingMap[classId];

            return {
              ...studentData,
              hierarchyOne: groupNameOne,
              hierarchyTwo: groupNameTwo,
              hierarchyThree: groupNameThree,
            };
          });
          setLessonStudentsData(updatedData);
        }
      },
      onError: (error) => {
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error.message);
      },
    });
  }

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;

    if (name === "0") {
      setFilters((filters) => ({
        ...filters,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: "",
      }));

      setTermIdByToday(termPeriodData, setTermId, value);
    }

    if (name === "1") {
      setFilters((filters) => ({
        ...filters,
        hierarchyOneId: value,
        hierarchyTwoId: "",
        hierarchyThreeId: "",
      }));

      setTermIdByToday(termPeriodData, setTermId, filters.schoolYearId, value);
    }

    if (name === "2") {
      setFilters((filters) => ({
        ...filters,
        hierarchyTwoId: value,
        hierarchyThreeId: "",
      }));

      setTermIdByToday(
        termPeriodData,
        setTermId,
        filters.schoolYearId,
        filters.hierarchyOneId,
        value,
      );
    }

    if (name === "3") {
      setFilters((filters) => ({
        ...filters,
        hierarchyThreeId: value,
      }));
    }

    if (name === "termDate") {
      setTermId(value);
    }

    if (name === "teachers") {
      setFilters((filters) => ({
        ...filters,
        selectedTeacherId: value,
      }));
    }

    if (name === "lessons") {
      setFilters((filters) => ({
        ...filters,
        selectedLessonId: value,
      }));

      if (value) {
        const forWhere = {
          schoolid: schoolId,
          lesson_id: value,
        };

        queryLessonStudentsData(forWhere);
        getEvalItemsByLessonId.mutate(forWhere, {
          onSuccess: (data) => {
            setEvalItemsData(data);
          },
          onError: (error) => {
            console.error(error); // 일단 콘솔에 에러를 출력합니다.
            console.error("위와 같은 에러가 났으니 고치삼");
            alert(t("common.messages.errorAlert") + error.message);
          },
        });

        // 수업계획서 데이터 가져오기
        lessonPlanQuery.mutate(
          { lessonId: value, schoolid: schoolId },
          {
            onSuccess: (data) => {
              setLessonPlanData(data);
            },
            onError: (error) => {
              console.error("수업계획서 조회 실패:", error);
              setLessonPlanData(null);
            },
          },
        );
      } else {
        setLessonPlanData(null);
      }
    }
  };

  const handleAddClick = (row) => {
    if (!lessonInfo && !lessonInfo?.id) {
      handleToastCenterTop(t("teacher.lessonRelated.selectSubjectMessage"));
      return;
    }

    const rowSchoolYearId = row?.schoolYearDates[0]?.school_year_id;
    const lessonSchoolYearId = lessonInfo?.school_year_id;

    if (rowSchoolYearId !== lessonSchoolYearId) {
      handleToastCenterTop(
        t("teacher.lessonRelated.differentSchoolYearMessage"),
      );
      return;
    }

    if (filters.selectedLessonId) {
      const filteredData = lessonStudentsData.filter(
        (r) =>
          r.school_year === filters.schoolYear && r.lesson_id === lessonInfo.id,
      );
      if (filteredData.find((r) => r.username === row.username)) {
        handleToastCenterTop(t("teacher.doActivities.alreadyAssigned"));
        return;
      }

      // tags가 배열이 아니면 빈 배열로 설정
      const tags = Array.isArray(lessonInfo.tags) ? lessonInfo.tags : [];
      // tags 배열 내의 각 객체를 순회하며 값을 3으로 설정
      const generatedTags = tags.map((tagObject) => {
        // 객체 내의 모든 키에 대해 값을 3으로 설정
        const updatedTagObject = {};
        Object.keys(tagObject).forEach((key) => {
          updatedTagObject[key] = "3"; // 값으로 문자열 "3"을 설정, 숫자로 설정하려면 3으로 변경
        });
        return updatedTagObject;
      });

      //데이터베이스에 저장할 데이터 만들기
      const addDataSet = {
        schoolid: lessonInfo.schoolid,
        school_year: lessonInfo.school_year,
        school_year_id: lessonInfo.school_year_id,
        lesson_id: lessonInfo.id,
        username: row.username,
        tags: generatedTags,
      };

      const forWhere = {
        schoolid: lessonInfo.schoolid,
        lesson_id: lessonInfo.id,
      };

      const checkOwner = lessonInfo?.teachers?.some(
        (teacher) => teacher.username === user.username,
      );
      if (!checkOwner && !hasPermission(null, "can_create")) {
        handleToastCenterTop(t("common.messages.ownerPermission"));
        return;
      }

      setIsLoadingModal(true);
      createLessonStudents.mutate(addDataSet, {
        onSuccess: (successMessage) => {
          console.log(successMessage);
          setIsLoadingModal(false);
          setIsAdded((prev) => [...prev, row.id]);
          setTimeout(() => {
            setIsAdded([]);
          }, 1500);
          queryLessonStudentsData(forWhere);
        },
        onError: (error) => {
          setIsLoadingModal(false);
          console.error(error); // 일단 콘솔에 에러를 출력합니다.
          console.error("위와 같은 에러가 났으니 고치삼");
          alert(t("common.messages.errorAlert") + error.message);
        },
      });
    } else {
      handleToastCenterTop(t("teacher.lessonRelated.selectSubjectMessage"));
    }
  };

  const handleAddAllClick = (rows) => {
    if (!lessonInfo && !lessonInfo?.id) {
      handleToastCenterTop(t("teacher.lessonRelated.selectSubjectMessage"));
      return;
    }

    if (lessonInfo) {
      const bulkDataSets = [];
      const addedStudents = []; // 성공적으로 추가될 학생들의 이름을 저장할 배열
      const duplicateStudents = []; // 중복으로 추가되지 않은 학생들의 이름을 저장할 배열

      let message;

      rows.forEach((row) => {
        const filteredData = lessonStudentsData.filter(
          (r) => r.school_year === filters.schoolYear,
        );

        const isDuplicate = filteredData.some(
          (r) => r.lesson_id === lessonInfo.id && r.username === row.username,
        );

        if (isDuplicate) {
          duplicateStudents.push(row.fullname);
          return;
        }

        const generatedTags = lessonInfo?.tags?.map((tagObject) => {
          const updatedTagObject = {};
          Object.keys(tagObject).forEach((key) => {
            updatedTagObject[key] = "3";
          });
          return updatedTagObject;
        });

        const addDataSet = {
          schoolid: lessonInfo.schoolid,
          school_year: lessonInfo.school_year,
          school_year_id: lessonInfo.school_year_id,
          lesson_id: lessonInfo.id,
          username: row.username,
          tags: generatedTags,
        };

        addedStudents.push(row.fullname);
        bulkDataSets.push(addDataSet);
      });

      if (bulkDataSets.length > 0) {
        const forWhere = {
          schoolid: lessonInfo.schoolid,
          lesson_id: lessonInfo.id,
        };

        const checkOwner = lessonInfo?.teachers?.some(
          (teacher) => teacher.username === user.username,
        );
        if (!checkOwner && !hasPermission(null, "can_create")) {
          handleToastCenterTop(t("common.messages.ownerPermission"));
          return;
        }

        setIsLoadingModal(true);
        createLessonStudentsBulk.mutate(bulkDataSets, {
          onSuccess: (successMessage) => {
            console.log(successMessage);
            setIsLoadingModal(false);
            // 성공적으로 추가된 row.id들을 setIsAddedAll로 처리
            setIsAddedAll(true);
            setTimeout(() => {
              setIsAddedAll(false);
            }, 1500);
            queryLessonStudentsData(forWhere);

            message = `${addedStudents.length}${t(
              "teacher.doActivities.addedStudents",
            )} <br>- ${addedStudents.join(", ")}`;

            if (duplicateStudents.length > 0) {
              message = `${addedStudents.length}${t(
                "teacher.doActivities.addedStudents",
              )} <br>- ${addedStudents.join(", ")} <br> ${
                duplicateStudents.length
              }${t(
                "teacher.doActivities.duplicateStudents",
              )} <br> - ${duplicateStudents.join(", ")}`;
            }
            handleToastCenterTop(message, 4000);
          },
          onError: (error) => {
            setIsLoadingModal(false);
            console.error(error);
            alert("에러 발생: " + error.message);
          },
        });
      } else {
        if (duplicateStudents.length > 0) {
          message = `${duplicateStudents.length}${t(
            "teacher.doActivities.duplicateStudents",
          )} <br> - ${duplicateStudents.join(", ")}`;
        }
        handleToastCenterTop(message, 4000);
      }
    } else {
      handleToastCenterTop(t("teacher.doActivities.selectActivity"));
    }
  };

  // "저장" 버튼 클릭 핸들러
  const saveChanges = (e) => {
    e.preventDefault();
    const dataSet = {
      id: e.target.name,
      tags: selectedOptions,
      schoolid: schoolId,
    };

    const checkOwner = lessonInfo.teachers.some(
      (teacher) => teacher.username === user.username,
    );
    if (!checkOwner && !hasPermission(null, "can_update")) {
      handleToastCenterTop(t("common.messages.ownerUpdatePermission"));
      return;
    }

    setIsLoadingModal(true);
    updateLessonTags.mutate(dataSet, {
      onSuccess: (successMessage) => {
        console.log(successMessage);
        setIsLoadingModal(false);
      },
      onError: (error) => {
        setIsLoadingModal(false);
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error.message);
      },
    });
  };

  // 선택 옵션 변경 핸들러
  const handleSelectChange = (tagName, newValue) => {
    setSelectedOptions((prevOptions) =>
      prevOptions.map((option) => {
        // Object.keys(option)[0]은 현재 옵션 객체의 키를 가져옵니다.
        // 이 키가 tagName과 일치하면, 새 값을 가진 객체를 반환합니다.

        if (Object.keys(option)[0] === tagName) {
          return { [tagName]: newValue };
        }
        // 일치하지 않는 경우, 원래 객체를 그대로 반환합니다.
        return option;
      }),
    );
  };

  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <InsertStudentsSidebar
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          handleAddClick={handleAddClick}
          isAdded={isAdded}
          isAddedAll={isAddedAll}
          handleAddAllClick={handleAddAllClick}
          schoolStageId={filters.hierarchyOneId}
          schoolStageOrganPath={filters.organPathForSort}
        />
        <div className="d-flex justify-content-end flex-wrap mb-3 mt-2">
          <div style={{ width: "95px" }} className="me-1">
            <DropdownSchoolYear
              settingData={settingData}
              handleDropdownChange={handleDropdownChange}
              schoolYearId={filters.schoolYearId}
              allYears={false}
            />
          </div>
          <div style={{ width: "95px" }} className="me-1">
            <DropdownHierarchyOne
              settingData={settingData}
              handleDropdownChange={handleDropdownChange}
              schoolYear={filters.schoolYear}
              hierarchyOneId={filters.hierarchyOneId}
              hierarchyOneTitle={t("common.labels.whole")}
              extraOption={true}
              extraOptionTitle={t("common.labels.schoolStage")}
            />
          </div>
          <div style={{ width: "95px" }} className="me-1">
            <DropdownHierarchyTwo
              settingData={settingData}
              handleDropdownChange={handleDropdownChange}
              schoolYear={filters.schoolYear}
              hierarchyOneId={filters.hierarchyOneId}
              hierarchyTwoId={filters.hierarchyTwoId}
              hierarchyTwoTitle={t("common.labels.whole")}
              extraOption={true}
              extraOptionTitle={t("common.labels.studentYear")}
            />
          </div>
          <div style={{ width: "95px" }} className="me-1">
            <DropdownHierarchyThree
              settingData={settingData}
              handleDropdownChange={handleDropdownChange}
              schoolYear={filters.schoolYear}
              hierarchyTwoId={filters.hierarchyTwoId}
              hierarchyThreeId={filters.hierarchyThreeId}
              hierarchyThreeTitle={t("common.labels.whole")}
              extraOption={true}
              extraOptionTitle={t("common.labels.class")}
            />
          </div>
          <div style={{ width: "95px" }} className="me-1">
            <DropdownTermDate
              termPeriodData={termPeriodData}
              handleDropdownChange={handleDropdownChange}
              termId={termId}
              schoolYearId={filters.schoolYearId}
              hierarchyOneId={filters.hierarchyOneId}
              hierarchyTwoId={filters.hierarchyTwoId}
            />
          </div>
          <div style={{ width: "95px" }}>
            <DropdownUniqueUsersInDisplayData
              displayData={userData}
              displayKey={"fullname"}
              valueKey={"username"}
              uniqueKey={"username"}
              sortKey={"fullname"}
              isDesc={false}
              handleDropdownChange={handleDropdownChange}
              selectedUser={filters.selectedTeacherId}
              selectName="teachers"
              dropdownTitle={t("teacher.lessonRelated.selectTeacher")}
            />
          </div>

          <div style={{ width: "95px" }}>
            <DropdownUniqueItems
              displayData={lessonList}
              displayKey={"subject_name"}
              valueKey={"id"}
              uniqueKey={"id"}
              sortKey={"subject_name"}
              isDesc={false}
              handleDropdownChange={handleDropdownChange}
              selectedItem={filters.selectedLessonId}
              selectName="lessons"
              dropdownTitle={t("teacher.lessonRelated.selectSubject")}
            />
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-auto">
            <h3 className="fw-bold">
              {t(
                "teacher.lessonRelated.assignAndRecord" ||
                  "학생배정 및 성적기록",
              )}
              <HelpHyperLink link={"https://youtu.be/FwGQYCUW698"} />
            </h3>
          </div>
          <div className="col-auto">
            <button
              className="btn btn-sm btn-secondary mt-2"
              onClick={toggleSidebar}
            >
              {t("common.labels.assign")}
            </button>
          </div>
          {evalItemsData &&
            evalItemsData.length > 0 &&
            (() => {
              // 평가계획서 데이터 존재 여부 확인
              const findItems = (parentId, level) =>
                evalItemsData.filter(
                  (item) =>
                    item.hierarchy_level === level &&
                    item.parent_id === parentId,
                );
              const findFinalLevelItems = () => {
                const finalItems = [];
                const level1Items = findItems(0, 1);
                level1Items.forEach((level1) => {
                  const level2Items = findItems(level1.id, 2);
                  if (level2Items.length === 0) {
                    finalItems.push({ finalItem: level1, parentItems: [] });
                  } else {
                    level2Items.forEach((level2) => {
                      const level3Items = findItems(level2.id, 3);
                      if (level3Items.length === 0) {
                        finalItems.push({
                          finalItem: level2,
                          parentItems: [level1],
                        });
                      } else {
                        level3Items.forEach((level3) => {
                          finalItems.push({
                            finalItem: level3,
                            parentItems: [level1, level2],
                          });
                        });
                      }
                    });
                  }
                });
                return finalItems;
              };
              const hasEvalPlanData = findFinalLevelItems().some(
                ({ finalItem }) =>
                  (finalItem.extra_data?.elements &&
                    finalItem.extra_data.elements.trim() !== "") ||
                  (finalItem.extra_data?.criteria &&
                    finalItem.extra_data.criteria.trim() !== ""),
              );
              return hasEvalPlanData ? (
                <div className="col-auto ms-2">
                  <div className="d-flex align-items-center gap-2 mt-2">
                    <input
                      type="checkbox"
                      checked={showEvalPlan}
                      onChange={(e) => setShowEvalPlan(e.target.checked)}
                      style={{ transform: "scale(1.2)" }}
                    />
                    <span style={{ fontSize: "14px" }}>
                      {t("teacher.lessonRelated.showEvalPlan") ||
                        "평가계획서 보기"}
                    </span>
                  </div>
                </div>
              ) : null;
            })()}

          {/* 수업계획서 누가기록 버튼 - 수업계획서가 존재할 때만 표시 */}
          {lessonPlanData && lessonPlanData?.data?.id && (
            <div className="col-auto ms-2">
              <button
                className="btn btn-sm btn-outline-primary mt-2"
                onClick={() => setIsLessonPlanDrawerOpen(true)}
              >
                {t("teacher.lessonRelated.lessonPlanRecord") ||
                  "수업계획서 누가기록"}
              </button>
            </div>
          )}
          {confirmerFlexibleData && confirmerFlexibleData.length > 0 && (
            <div className="col-auto ms-auto">
              <div className="d-flex align-items-center gap-2">
                {!isConfirmerLoggedIn ? (
                  <>
                    <input
                      style={{ width: "200px", height: "38px" }}
                      placeholder="확인자암호"
                      type="password"
                      className="form-control"
                      value={loginKey}
                      onChange={handleLoginKeyChange}
                    />
                    <button
                      type="button"
                      className="btn btn-info"
                      onClick={handleLoginClick}
                    >
                      로그인
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleLogoutClick}
                  >
                    로그아웃
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
        <UniDivider margin="10px 0" />

        <form>
          <div className="d-flex" style={{ fontSize: "14px" }}>
            <div className="me-2 ms-2">
              <div
                className="text-center"
                style={{ fontWeight: "bold", marginBottom: "6px" }}
              >
                {t("common.labels.lessonTag")}
              </div>
              <button
                onClick={saveChanges}
                className="btn btn-sm btn-outline-primary m-0"
                name={lessonInfo?.id}
                style={{ fontSize: "14px" }}
              >
                {t("common.labels.saveTag")}
              </button>
            </div>
            <div
              style={{ display: "flex", alignItems: "flex-end", gap: "5px" }}
            >
              {lessonInfo?.tags?.map((tag, index) => {
                const tagName = Object.keys(tag)[0];
                const optionValue =
                  selectedOptions.find(
                    (option) => Object.keys(option)[0] === tagName,
                  )?.[tagName] ?? "";

                return (
                  <div
                    key={index}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      className="text-center"
                      style={{ marginBottom: "5px" }}
                    >
                      {tagName}
                    </div>
                    <select
                      className="form-control p-1"
                      value={optionValue}
                      onChange={(e) =>
                        handleSelectChange(tagName, e.target.value)
                      }
                    >
                      <option value="1">{t("common.labels.veryWeak")}</option>
                      <option value="2">{t("common.labels.weak")}</option>
                      <option value="3">{t("common.labels.normal")}</option>
                      <option value="4">{t("common.labels.strong")}</option>
                      <option value="5">{t("common.labels.veryStrong")}</option>
                    </select>
                  </div>
                );
              })}
            </div>
          </div>
        </form>

        <table className="table text-center align-middle">
          <tbody>
            <tr>
              <th style={{ width: "10%" }}>{t("common.labels.termName")}</th>
              <th style={{ width: "8%" }}>{t("common.labels.schoolStage")}</th>
              <th style={{ width: "8%" }}>{t("common.labels.studentYear")}</th>
              <th style={{ width: "8%" }}>{t("common.labels.class")}</th>
              <th style={{ width: "25%" }}>
                {t("teacher.lessonRelated.subjectTitle") || "과목명"}
              </th>
              <th style={{ width: "10%" }}>{t("common.user.teacher")}</th>
              {lessonInfo?.evaluation_type === "100점제" ? (
                <>
                  <th style={{ width: "11%", fontSize: "smaller" }}>
                    {t("teacher.lessonRelated.evaluationType")}
                    <br />
                    {
                      lessonSetting?.find((r) => r.item_code === "evalArea100")
                        ?.saved_setting
                    }
                  </th>
                </>
              ) : (
                <th style={{ width: "11%" }}>
                  {t("teacher.lessonRelated.evaluationType")}
                </th>
              )}
              {lessonInfo?.evaluation_type === "100점제" &&
                lessonSetting
                  ?.find((r) => r.item_code === "evalArea100")
                  ?.detailed_setting?.map((setting, index) => (
                    <th key={index} style={{ fontSize: "smaller" }}>
                      {t("teacher.lessonRelated.weight")}
                      <br />
                      {setting}
                    </th>
                  ))}
            </tr>
            <tr>
              <td>
                {lessonInfo &&
                  lessonInfo.school_year &&
                  lessonInfo.termName &&
                  lessonInfo.school_year + "-" + lessonInfo.termName}
              </td>
              <td>{lessonInfo && lessonInfo.hierarchyOne}</td>
              <td>{lessonInfo && lessonInfo.hierarchyTwo}</td>
              <td>{lessonInfo && lessonInfo.hierarchyThree}</td>
              <td>{lessonInfo && lessonInfo.subject_name}</td>
              <td>
                {lessonInfo && Array.isArray(lessonInfo?.teachers)
                  ? lessonInfo?.teachers
                      ?.map((user) => user.tname.toString())
                      .join(",")
                  : ""}
              </td>
              <td>{lessonInfo && lessonInfo.evaluation_type}</td>
              {lessonInfo?.evaluation_type === "100점제" &&
                lessonSetting
                  ?.find((r) => r.item_code === "evalArea100")
                  ?.detailed_setting?.map((setting, index) => (
                    <td key={index}>{lessonInfo.eval_area_weights[setting]}</td>
                  ))}
            </tr>
          </tbody>
        </table>

        {!lessonInfo?.teachers?.some(
          (teacher) => teacher.username === user.username,
        ) && !hasPermission(null, "can_read") ? (
          <SimpleAlertMessageBlock
            message={t("common.messages.noAccessPermission")}
          />
        ) : lessonInfo?.evaluation_type ? (
          <RenderComponent
            evaluationType={lessonInfo.evaluation_type}
            lessonStudentsData={lessonStudentsData}
            setLessonStudentsData={setLessonStudentsData}
            lessonSetting={lessonSetting}
            updateLessonStudents={updateLessonStudents}
            updateLessonStudentsBulk={updateLessonStudentsBulk}
            deleteLessonStudents={deleteLessonStudents}
            lessonInfo={lessonInfo}
            evalItemsData={evalItemsData}
            schoolId={schoolId}
            confirmerFlexibleData={confirmerFlexibleData}
            confirmRecordsData={confirmRecordsData}
            createOrUpdateConfirm={createOrUpdateConfirm}
            isConfirmerLoggedIn={isConfirmerLoggedIn}
            showEvalPlan={showEvalPlan}
          />
        ) : null}

        {/* 수업계획서 누가기록 Drawer */}
        {isLessonPlanDrawerOpen && lessonPlanData && (
          <LessonPlanRecordDrawer
            lessonInfo={lessonInfo}
            lessonPlanData={lessonPlanData}
            onClose={() => setIsLessonPlanDrawerOpen(false)}
            upsertLessonPlan={upsertLessonPlan}
            schoolId={schoolId}
            settingData={settingData}
            lessonPlanQuery={lessonPlanQuery}
            setLessonPlanData={setLessonPlanData}
          />
        )}
      </div>
    </div>
  );
}

function RenderComponent({
  evaluationType,
  lessonStudentsData,
  lessonSetting,
  lessonInfo,
  setLessonStudentsData,
  updateLessonStudents,
  updateLessonStudentsBulk,
  deleteLessonStudents,
  evalItemsData,
  schoolId,
  confirmerFlexibleData,
  confirmRecordsData,
  createOrUpdateConfirm,
  isConfirmerLoggedIn,
  showEvalPlan,
}) {
  switch (evaluationType) {
    case "평가항목별":
      return (
        <>
          {schoolId === "sepum" ? (
            <SepumLessonStudentsItemsTable
              lessonStudentsData={lessonStudentsData}
              setLessonStudentsData={setLessonStudentsData}
              evaluationType={evaluationType}
              lessonSetting={lessonSetting}
              updateLessonStudents={updateLessonStudents}
              updateLessonStudentsBulk={updateLessonStudentsBulk}
              deleteLessonStudents={deleteLessonStudents}
              lessonInfo={lessonInfo}
              evalItemsData={evalItemsData}
            />
          ) : (
            <LessonStudentsItemsTable
              lessonStudentsData={lessonStudentsData}
              setLessonStudentsData={setLessonStudentsData}
              evaluationType={evaluationType}
              lessonSetting={lessonSetting}
              updateLessonStudents={updateLessonStudents}
              updateLessonStudentsBulk={updateLessonStudentsBulk}
              deleteLessonStudents={deleteLessonStudents}
              lessonInfo={lessonInfo}
              evalItemsData={evalItemsData}
              showEvalPlan={showEvalPlan}
            />
          )}

          {schoolId === "haven" || schoolId === "sampleschool" ? (
            <HavenExtraTable
              lessonStudentsData={lessonStudentsData}
              setLessonStudentsData={setLessonStudentsData}
              evaluationType={evaluationType}
              lessonSetting={lessonSetting}
              updateLessonStudents={updateLessonStudents}
              updateLessonStudentsBulk={updateLessonStudentsBulk}
              deleteLessonStudents={deleteLessonStudents}
              lessonInfo={lessonInfo}
              evalItemsData={evalItemsData}
            />
          ) : null}
        </>
      );
    case "커스텀":
      return (
        <CustomTableSwitch
          lessonStudentsData={lessonStudentsData}
          setLessonStudentsData={setLessonStudentsData}
          evaluationType={evaluationType}
          lessonSetting={lessonSetting}
          updateLessonStudents={updateLessonStudents}
          updateLessonStudentsBulk={updateLessonStudentsBulk}
          deleteLessonStudents={deleteLessonStudents}
          lessonInfo={lessonInfo}
          evalItemsData={evalItemsData}
          schoolId={schoolId}
        />
      );
    default:
      return (
        <>
          <LessonStudentsTable
            lessonStudentsData={lessonStudentsData}
            setLessonStudentsData={setLessonStudentsData}
            evaluationType={evaluationType}
            lessonSetting={lessonSetting}
            updateLessonStudents={updateLessonStudents}
            updateLessonStudentsBulk={updateLessonStudentsBulk}
            deleteLessonStudents={deleteLessonStudents}
            lessonInfo={lessonInfo}
            confirmerFlexibleData={confirmerFlexibleData}
            confirmRecordsData={confirmRecordsData}
            createOrUpdateConfirm={createOrUpdateConfirm}
            isConfirmerLoggedIn={isConfirmerLoggedIn}
          />
          {schoolId === "haven" || schoolId === "sampleschool" ? (
            <HavenExtraTable
              lessonStudentsData={lessonStudentsData}
              setLessonStudentsData={setLessonStudentsData}
              evaluationType={evaluationType}
              lessonSetting={lessonSetting}
              updateLessonStudents={updateLessonStudents}
              updateLessonStudentsBulk={updateLessonStudentsBulk}
              deleteLessonStudents={deleteLessonStudents}
              lessonInfo={lessonInfo}
              evalItemsData={evalItemsData}
            />
          ) : null}
        </>
      );
  }
}
